// ----------------------------------------------------------------------

export default function Table(theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1.5, 2),
          borderBottomColor: theme.palette.divider,
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
          fontWeight: theme.typography.fontWeightBold,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          minHeight: 48,
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(1),
        },
      },
    },
  };
}
